import {
  makeStyles,
  IconButton,
  Tooltip,
  Link as MaterialLink,
} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { SyntheticEvent } from 'react';
import { useLocation } from 'react-router-dom';
import { Venture } from '../../api/ventures/types/Venture';
import { getRoutePath, Pages } from '../../router/constants';
import { Link } from '../common';

interface DescriptionIconProps {
  venture: Venture;
}

const useStyles = makeStyles(() => ({
  link: {
    '&:hover': {
      borderBottom: 'none',
    },
  },
}));

function QuarterlyReportIcon({ venture }: DescriptionIconProps) {
  const classes = useStyles();
  const location = useLocation();

  return (
    <Tooltip title={'Quarterly Report'}>
      <MaterialLink
        data-testid='quarterly-report-link-icon'
        onClick={(e: SyntheticEvent<any>) => e.stopPropagation()}
        component={Link}
        className={classes.link}
        to={{
          pathname: getRoutePath(Pages.VENTURE_QUARTERLY_REPORT, {
            ventureId: venture.id,
          }),
          state: {
            prevPath: `${location.pathname}${location.search}`,
          },
        }}>
        <IconButton data-testid='founder-notes-icon'>
          <AssessmentIcon />
        </IconButton>
      </MaterialLink>
    </Tooltip>
  );
}

export default QuarterlyReportIcon;
